import React from "react";
import { cn } from "@/shared/utils/shadcn";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/shared/ui/HoverCard";
import { DimensionCard } from "@/shared/widgets/DimensionCard";
import { useDictionary } from "@/shared/hooks/content/useDictionary";
import { PersonScore } from "@/features/people/hooks/useDimensionsWithScores";

interface DimensionTagProps {
  dim_id: number;
  label: string;
  score?: PersonScore;
  scores?: PersonScore[];
  group: string;
}

const DimensionTag: React.FC<DimensionTagProps> = ({
  dim_id,
  label,
  score,
  group,
  scores,
}) => {
  const { getTerm } = useDictionary();
  const tagsClasses = {
    values:
      "bg-orange-100 text-orange-500 hover:bg-orange-500 hover:text-white",
    personality: "bg-blue-100 text-blue-500 hover:bg-blue-500 hover:text-white",
    competencies:
      "bg-green-100 text-green-500 hover:bg-green-500 hover:text-white",
  };

  const title = getTerm(dim_id, "name") || "";
  const description = getTerm(dim_id, "description") || "";

  return (
    <HoverCard openDelay={0} closeDelay={100}>
      <HoverCardTrigger asChild>
        <span
          className={cn(
            "cursor-pointer text-md font-normal px-2 py-1 rounded-sm print:text-sm",
            tagsClasses[group as keyof typeof tagsClasses]
          )}
        >
          {label?.toLowerCase() || ""}
        </span>
      </HoverCardTrigger>
      <HoverCardContent>
        <DimensionCard
          title={title || " "}
          description={description || ""}
          scores={scores || []}
          showAverageScore={false}
          showScore
          score={score}
          id={dim_id}
        />
      </HoverCardContent>
    </HoverCard>
  );
};

export default DimensionTag;
